import { Tab, TabbedPage } from "components/Shared/TabbedPage";
import { useState } from "react";
import AddAADUser from "./AddAADUser";
import { makeStyles } from '@material-ui/core';
import ModifyUserGrid from "./ModifyUserGrid";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 20
    }
}));

const tabs = [
    new Tab({ label: "Add User", value: "AddUser", scope: "AdminConfig", action: "create" }),
    new Tab({ label: "Modify User", value: "ModifyUser", scope: "AdminConfig", action: "update" })
]


const UserManagement = () => {
    const classes = useStyles();
    const [currentTab, setCurrentTab] = useState('AddUser');
    return (
        <div className={classes.root}>
            <TabbedPage
                tabs={tabs}
                activeTab={currentTab}
                tabSetterFunc={setCurrentTab}
                elevation={0}
            >
                {(() => {
                    switch (currentTab) {
                        case "AddUser": return <AddAADUser />
                        case "ModifyUser": return <ModifyUserGrid />
                        default: return <AddAADUser />
                    }
                })()}
            </TabbedPage>
        </div>
    )
}

export default UserManagement;